import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import Logo from './Logo';

interface CommonHeaderProps {
  title?: string;
  showBackButton?: boolean;
  backTo?: string;
  showHomeButton?: boolean;
  className?: string;
  children?: React.ReactNode;
}

const CommonHeader: React.FC<CommonHeaderProps> = ({
  title,
  showBackButton = true,
  backTo,
  showHomeButton = false,
  className = '',
  children
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (backTo) {
      navigate(backTo);
    } else if (location.key !== 'default') {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  const handleHome = () => {
    navigate('/');
  };

  return (
    <header className={`bg-white shadow-sm border-b border-gray-200 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-4">
          <div className="flex items-center space-x-4">
            {showBackButton && (
              <button
                onClick={handleBack}
                className="p-2 text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-lg transition-colors"
                title="Go back"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
            )}
            
            {showHomeButton && (
              <button
                onClick={handleHome}
                className="p-2 text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-lg transition-colors"
                title="Go home"
              >
                <Home className="w-5 h-5" />
              </button>
            )}

            <div className="flex items-center space-x-3">
              <Logo size="md" />
              {title && (
                <h1 className="text-xl font-bold text-gray-900">{title}</h1>
              )}
            </div>
          </div>

          {children && (
            <div className="flex items-center space-x-4">
              {children}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default CommonHeader;
